import type {Asset, FocalPointAsset, FromResolver} from "../types/magnolia-types";
import {isEmpty} from "./string-utils";
export function resolveAssetAlt(asset: FromResolver<Asset<any> | FocalPointAsset> | undefined) {
  if (!asset) return;
  if (typeof asset === 'string') return;
  if (!asset.metadata) return;

  const description = asset.metadata.description;
  if (!isEmpty(description)) return description;

  const caption = asset.metadata.caption;
  if (!isEmpty(caption)) return caption;

  const subject = asset.metadata.subject?.[0];
  if (!isEmpty(subject)) return subject;

  const title = asset.metadata.title;
  if (!isEmpty(title)) return title;

  return asset["@name"];
}
